export enum QCMsTab {
  All = "All",
  ToGenerate = "ToGenerate",
  Generated = "Generated",
}
